import { LongueurMaxRepetitionCaracteres } from './Constants';

export const validateSequence = (value: string) => {
  let sequenceCount = 1;
  let lastValue = 0;
  for (let i = 0; i < value.length; i++) {
    if (value.charCodeAt(i) === lastValue) {
      sequenceCount += 1;
      if (sequenceCount > LongueurMaxRepetitionCaracteres) {
        return false;
      }
    } else {
      sequenceCount = 1;
    }
    lastValue = value.charCodeAt(i);
  }
  return true;
};
